<template>
  <!-- header -->
  <Header :hide-play-free-now="abTestNightScene === 'b' && (scene === 'night' || oldScene === 'night' && transitionLeave)" />
  <!-- background -->
  <div v-if="scene === 'underground' || scene === 'footer'" class="underlay underlay--background wall faded" />
  <div v-if="scene === 'night' || scene === 'village' || scene === 'friends' || scene === 'world'" class="underlay underlay--background bg-blue" />
  <div class="appbackground">
    <transition :name="`background-${transition}`">
      <Background v-if="scene === 'village' || scene === 'friends' || scene === 'world'" :data-scene="scene" :class="{abt: abTestNightScene === 'b'}" />
    </transition>
  </div>
  <!-- scene -->
  <div v-if="loading" class="spinner-circle"></div>
  <transition :name="`scene-${transition}`" :mode="mode" @before-leave="transitionLeave = true" @before-enter="transitionLeave = false">
    <Night v-if="scene === 'night' && abTestNightScene === 'a'" />
    <Nightv2 v-else-if="scene === 'night' && abTestNightScene === 'b'" />
    <Ground v-else-if="scene === 'village' || scene === 'friends' || scene === 'world'" :scene="scene" :class="resizing" />
    <div v-else-if="scene === 'underground' || scene === 'footer'" ref="underground" class="underground">
      <transition :name="`scene-${transition}`" :mode="mode">
        <Underground v-if="scene === 'underground'" />
        <Footer v-else-if="scene === 'footer'" />
      </transition>
    </div>
  </transition>
</template>

<script>
import '@/assets/scss/landing/theme.scss'
import '@/assets/fontawesome/fontawesome.scss'
import '@/assets/fontawesome/brands.scss'

import Header from '@/components/Header.vue'
import Night from '@/components/screens/Night.vue'
import Nightv2 from '@/components/screens/Nightv2.vue'
import Cookie from '@/services/browser/Cookie'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'App',

  components: {
    Header,
    Night,
    Nightv2,
    Background: defineAsyncComponent(() => import(/* webpackChunkName: "ground" */ '@/components/Background.vue')),
    Ground: defineAsyncComponent(() => import(/* webpackChunkName: "ground" */ '@/components/screens/Ground.vue')),
    Underground: defineAsyncComponent(() => import(/* webpackChunkName: "underground" */ '@/components/screens/Underground.vue')),
    Footer: defineAsyncComponent(() => import(/* webpackChunkName: "footer" */ '@/components/screens/Footer.vue')),
  },

  data () {
    return {
      transition: 'night-village',
      mode: 'out-in',
      // heights
      windowHeight: -1,
      undergroundHeight: -1,
      // resize
      resizing: '',
      resizingTimeout: null,
      // touch
      touchTicking: false,
      xDown: null,
      yDown: null,
      // scroll
      scrollTicking: false,
      scrollBusy: false,
      scrollBusyInterval: null,
      scrollingInternally: false,
      scrollingInternallyInterval: null,
      // ab test:
      abTestNightScene: null, // it will be 'a' or 'b' depending on the  'optVer' cookie value
      oldScene: null,
      transitionLeave: false,
      loading: false, // used for displaying the loading spinner while getting the 'optVer' cookie for displaying Night or Nightv2 verion
    }
  },

  computed: {
    scene () {
      return this.$store.getters.getScene
    }
  },

  watch: {
    scene (newValue, oldValue) {
      this.transition = `${this.getSceneTransition(oldValue)}-${this.getSceneTransition(newValue)}`
      this.undergroundHeight = -1
      this.oldScene = oldValue
    }
  },
  created() {
    this.checkABTestCookie();
  },
  mounted () {
    // api
    this.$store.dispatch('setContentHome')
    // resize
    this.calculateHeights()
    window.addEventListener('resize', this.resize)
    // events
    window.addEventListener('wheel', this.requestScrollTick, { passive: true })
    window.addEventListener('keydown', this.handleKey)
    // touch
    window.addEventListener('touchstart', this.handleTouchStart, { passive: true })
    window.addEventListener('touchmove', this.requestTouchTick, { passive: true })

    // Landing Page Cookie.
    Cookie.set("maplestoryLanding", "true")

  },

  methods: {
    getSceneTransition (str) {
      let transition = str
      switch (str) {
        case 'friends':
        case 'village':
        case 'world':
          transition = 'ground'
          break;
        default:
          transition = str
          break;
      }
      return transition
    },
    resize () {
      clearTimeout(this.resizingTimeout)
      // resizing
      this.resizing = 'resizing'
      this.resizingTimeout = setTimeout(() => {
        this.resizing = ''
      }, 500)
      // heights
      this.calculateHeights()
    },
    calculateHeights () {
      this.windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      this.undergroundHeight = -1
    },
    navigateScene (direction) {
      if (this.scrollingInternally) {
        return false
      }
      this.scrollBusy = true
      clearTimeout(this.scrollBusyInterval)
      this.scrollBusyInterval = setTimeout(() => {
        this.scrollBusy = false
      }, 2000)
      // left
      if (direction === 'left') {
        if (this.scene === 'village') {
          this.$store.dispatch('setScene', 'friends')
        }
        else if (this.scene === 'world') {
          this.$store.dispatch('setScene', 'village')
        }
      }
      // right
      if (direction === 'right') {
        if (this.scene === 'village') {
          this.$store.dispatch('setScene', 'world')
        }
        else if (this.scene === 'friends') {
          this.$store.dispatch('setScene', 'village')
        }
      }
      // down
      if (direction === 'down') {
        if (this.scene === 'night') {
          this.$store.dispatch('setScene', 'village')
        }
        else if (this.scene === 'village') {
          this.$store.dispatch('setScene', 'underground')
        }
        else if (this.scene === 'underground') {
          this.$store.dispatch('setScene', 'footer')
        }
      }
      // up
      if (direction === 'up') {
        if (this.scene === 'village' || this.scene === 'friends' || this.scene === 'world') {
          this.$store.dispatch('setScene', 'night')
        }
        else if (this.scene === 'underground') {
          this.$store.dispatch('setScene', 'village')
        }
        else if (this.scene === 'footer') {
          this.$store.dispatch('setScene', 'underground')
        }
      }
    },
    // ---
    // key
    // ---
    handleKey (e) {
      e = e || window.event
      if (e.keyCode) {
        switch (e.keyCode) {
          case 37: // left
          case 65: // A
            this.navigateScene('left')
            break
          case 39: // right
          case 68: // D
            this.navigateScene('right')
            break
          case 40: // down
          case 83: // S
            this.navigateScene('down')
            break
          case 38: // up
          case 87: // W
            this.navigateScene('up')
            break
          default:
            break
        }
      }
    },
    // ------
    // scroll
    // ------
    setScrollingInternally () {
      clearTimeout(this.scrollingInternallyInterval)
      this.scrollingInternally = true
      this.scrollingInternallyInterval = setTimeout(() => {
        this.scrollingInternally = false
      }, 500)
    },
    requestScrollTick (event) {
      if (!this.scrollTicking) {
        requestAnimationFrame(() => {
          this.checkScrollDirection(event)
        })
      }
      this.scrollTicking = true
    },
    checkScrollDirection (event) {
      if (!this.scrollBusy) {
        if (this.$refs.underground && this.undergroundHeight === -1) {
          this.undergroundHeight = this.$refs.underground.clientHeight
        }
        const scrollTop = this.getScrollTop()
        if (this.checkScrollDirectionIsUp(event)) {
          // scroll UP
          if (scrollTop === 0) {
            this.navigateScene('up')
          } else {
            this.setScrollingInternally()
          }
        } else {
          // scroll DOWN
          if (scrollTop + this.windowHeight >= this.undergroundHeight) {
            this.navigateScene('down')
          } else {
            this.setScrollingInternally()
          }
        }
      }
      this.scrollTicking = false
    },
    checkScrollDirectionIsUp (event) {
      if (event.wheelDelta) {
        return event.wheelDelta > 0
      }
      return event.deltaY < 0
    },
    getScrollTop () {
      return window.scrollY
    },
    // -----
    // touch
    // -----
    requestTouchTick (event) {
      if (!this.touchTicking) {
        requestAnimationFrame(() => {
          this.handleTouchMove(event)
        })
      }
      this.touchTicking = true
    },
    handleTouchStart (event) {
      this.xDown = event.touches[0].clientX
      this.yDown = event.touches[0].clientY
    },
    handleTouchMove (event) {
      if (!this.xDown || !this.yDown) {
        this.touchTicking = false
        return
      }
      if (this.$refs.underground && this.undergroundHeight === -1) {
        this.undergroundHeight = this.$refs.underground.clientHeight
      }
      const scrollTop = this.getScrollTop()
      const xDiff = this.xDown - event.touches[0].clientX
      const yDiff = this.yDown - event.touches[0].clientY
      // most significant (x or y)
      if (Math.abs(yDiff) > Math.abs(xDiff)) {
        if (yDiff > 0) {
          // swipe DOWN
          if (scrollTop + this.windowHeight >= this.undergroundHeight) {
            this.navigateScene('down')
          } else {
            // this.setScrollingInternally()
          }
        } else {
          // swipe UP
          if (window.scrollY === 0) {
            this.navigateScene('up')
          } else {
            // this.setScrollingInternally()
          }
        }
      } else {
        if (xDiff > 0) {
          // swipe RIGHT
          this.navigateScene('right')
        } else {
          // swipe LEFT
          this.navigateScene('left')
        }
      }
      /* eslint-enable */
      this.xDown = null
      this.yDown = null
      this.touchTicking = false
    },
    async checkABTestCookie() {
      let checkInterval = 100; // ms
      let checkCounts = 10;

      if (!this.abTestNightScene) {
        this.loading = true;
        let cookieName = 'optVer';

        let optVer = Cookie.get(cookieName);
        if (optVer && (optVer === 'a' || optVer === 'b')) {
          this.loading = false;
          return this.abTestNightScene = optVer;
        }
        else if (this.$route.query && this.$route.query.utm_campaign) {
          for (let i = 1; i <= checkCounts; i++) {
            optVer = Cookie.get(cookieName);
            if (optVer && (optVer === 'a' || optVer === 'b')) {
              this.loading = false;
              this.abTestNightScene = optVer;
              break;
            }
            else {
              await new Promise((resolve) => setTimeout(resolve, checkInterval)); //utm_campaign exist but no optVer cookie await checkInterval ms
              if (i === checkCounts) {
                // display the variant 'a' in case checkInterval * checkCounts seconds passed and there's still no 'optVer' cookie
                this.loading = false;
                this.abTestNightScene = 'a';
                this.$gtm.trackEvent({
                  event: 'Google Optimize timeout',
                })
              }
            }
          }
        }
        else {
          // no utm_campaign and no optVer cookie, display variant 'a'
          this.loading = false;
          this.abTestNightScene = 'a';
        }
      }
		},
  }
}
</script>

<style scoped lang="scss">
.appbackground {
  position: fixed;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.underground {
  position: relative;
  z-index: 0;
}
.spinner-circle {
  display: inline-block;
  border: 6px solid lighten(#262626, 45%);
  border-top: 6px solid #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin-top: -4px;
  animation: spin 1s linear infinite;
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
</style>
